import styled from "styled-components";

interface IProps {
  variant: "primary" | "secondary";
}

export const Button = styled.button<IProps>`
  ${({ variant }) => `
  display: block;
  transition: all 0.2s;
  cursor: pointer;
  border: none;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  height: ${variant === "secondary" ? "2rem" : "3rem"} ;
  font-size: ${variant === "secondary" ? "14px" : "16px"}; 
  border-radius: 0;
  font-weight: 700;
  background-color: ${variant === "secondary" ? "#556069" : "#003057"};
  color: #fff;
  cursor: pointer;
  `}
`;
